import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardHeader, CardContent, TextField, Button, Grid } from '@mui/material';
import Swal from 'sweetalert2';
import { SwalConfig } from '../../utils/swalConfig';
import { meetingsData } from '../../Data/Kontak/Meeting';

const AddMeeting = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    requesterName: '',
    room: '',
    date: '',
    startTime: '',
    endTime: '',
    attendees: 1,
    purpose: '',
    status: 'Pending',
    notes: ''
  });

  const handleChange = (k) => (e) => setForm(prev => ({ ...prev, [k]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const stored = localStorage.getItem('meetings');
    const list = stored ? JSON.parse(stored) : meetingsData.slice();
    const id = `m${Date.now()}`;
    const item = { ...form, id, _id: id };
    list.unshift(item);
    localStorage.setItem('meetings', JSON.stringify(list));
    SwalConfig.success('Tersimpan', 'Pengajuan meeting berhasil disimpan', 1400);
    navigate('/kontak/meeting');
  };

  return (
    <Card>
      <CardHeader title="Tambah Pengajuan Meeting" />
      <CardContent>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}><TextField fullWidth label="Requester Name" value={form.requesterName} onChange={handleChange('requesterName')} required /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Room" value={form.room} onChange={handleChange('room')} required /></Grid>
            <Grid item xs={12} md={4}><TextField fullWidth type="date" label="Date" InputLabelProps={{ shrink: true }} value={form.date} onChange={handleChange('date')} required /></Grid>
            <Grid item xs={6} md={4}><TextField fullWidth type="time" label="Start" InputLabelProps={{ shrink: true }} value={form.startTime} onChange={handleChange('startTime')} required /></Grid>
            <Grid item xs={6} md={4}><TextField fullWidth type="time" label="End" InputLabelProps={{ shrink: true }} value={form.endTime} onChange={handleChange('endTime')} required /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Purpose" value={form.purpose} onChange={handleChange('purpose')} required /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth type="number" label="Attendees" value={form.attendees} onChange={handleChange('attendees')} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Notes" value={form.notes} onChange={handleChange('notes')} /></Grid>
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button variant="contained" type="submit">Simpan</Button>
                <Button variant="outlined" onClick={() => navigate('/kontak/meeting')}>Batal</Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AddMeeting;
